import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/complaint";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function useComplaintForm(props) {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [key, setKey] = createSignal(null);
  const [form, setForm] = createStore({
    name: "",
  });

  const clearForm = () => {
    setForm('name', '');
  }

  const fetchInfo = async (pid) => {
    setFetching(true);
    setKey(pid);
    try {
      const data = await get(key());
      setForm('name', data.entity.name);
    } catch (error) {
      throw error;
    }  finally {
      setFetching(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };

  const handleSave = async (ev) => {
    ev?.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));

      if (key() !== null) {
        formData.append('id', key());
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        props?.onClose();
        props?.onRefresh();
        return;
      }

      errorToast(data.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  onMount(async () => {
  })

  return {
    loading,
    clearForm,
    fetching,
    form,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange,
  };
}
